import React from "react";
import type { Incident } from "../types/dashboard.js";
import { SeverityBadge, StatusBadge } from "./SeverityBadge.js";
import { formatTaipeiTime } from "../../lib/time.js";

type Props = {
  incidents: Incident[];
  compact?: boolean;
};

function formatTs(iso: string): string {
  return formatTaipeiTime(iso);
}

export default function IncidentTable({ incidents, compact = false }: Props): React.ReactElement {
  return (
    <>
      {/* Desktop / tablet table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="table-header w-20">時間</th>
              <th className="table-header">案場 / 地點</th>
              <th className="table-header w-24">嚴重度</th>
              <th className="table-header w-24">狀態</th>
              {!compact && <th className="table-header">說明</th>}
              {!compact && <th className="table-header w-28">巡邏員</th>}
            </tr>
          </thead>
          <tbody>
            {incidents.map((inc) => (
              <tr key={inc.id} className="table-row">
                <td className="table-cell font-mono text-text-secondary">
                  {formatTs(inc.ts)}
                </td>
                <td className="table-cell">
                  <div className="font-medium text-text-primary">{inc.site}</div>
                  <div className="text-xs text-text-secondary font-mono mt-0.5">
                    {inc.location}
                  </div>
                </td>
                <td className="table-cell">
                  <SeverityBadge severity={inc.severity} />
                </td>
                <td className="table-cell">
                  <StatusBadge status={inc.status} />
                </td>
                {!compact && (
                  <td className="table-cell text-text-secondary">{inc.message}</td>
                )}
                {!compact && (
                  <td className="table-cell text-text-secondary">{inc.officer ?? "—"}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile cards */}
      <div className="md:hidden space-y-3">
        {incidents.map((inc) => (
          <div key={inc.id} className="card p-3">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-medium text-text-primary truncate">{inc.site}</div>
                <div className="text-xs text-text-secondary font-mono mt-0.5 truncate">
                  {inc.location}
                </div>
              </div>
              <span className="font-mono text-xs text-text-secondary flex-shrink-0">
                {formatTs(inc.ts)}
              </span>
            </div>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <SeverityBadge severity={inc.severity} />
              <StatusBadge status={inc.status} />
              {inc.officer && (
                <span className="text-xs text-text-secondary">巡邏員：{inc.officer}</span>
              )}
            </div>
            <p className="mt-2 text-sm text-text-secondary leading-relaxed">{inc.message}</p>
          </div>
        ))}
      </div>
    </>
  );
}
